import React, { useState, useEffect } from 'react';
import authService from '../../services/authService';
import settingsService from '../../services/settingsService';
import './ResetPassword.css';

const ResetPassword = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [branding, setBranding] = useState({});

    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    useEffect(() => {
        let cancelled = false;
        settingsService.getPublicSettings().then(settings => {
            if (!cancelled) setBranding(settings);
        });
        return () => { cancelled = true; };
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (password.length < 8) {
            setError('Password must be at least 8 characters.');
            return;
        }

        if (password !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        setIsLoading(true);

        try {
            await authService.resetPassword(token, password);
            setSuccess(true);
        } catch (err) {
            setError(err.message || 'Failed to reset password. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const loginLogoUrl = branding.login_logo_url;
    const loginBgUrl = branding.login_background_url;
    const companyDisplayName = branding.company_name || 'ConfigSelect';

    const leftStyle = loginBgUrl
        ? { backgroundImage: `url(${loginBgUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' }
        : {};

    if (!token) {
        return (
            <div className="login-container">
                <div className={`login-left ${loginBgUrl ? 'login-left-image' : ''}`} style={leftStyle}>
                    <div className={`login-logo-container ${loginBgUrl ? 'login-logo-overlay' : ''}`}>
                        {loginLogoUrl ? (
                            <img src={loginLogoUrl} alt={companyDisplayName} className="login-logo-img" />
                        ) : (
                            <>
                                <h1 className="login-brand">{companyDisplayName}</h1>
                                <p className="login-tagline">Product Configurator</p>
                            </>
                        )}
                    </div>
                </div>
                <div className="login-right">
                    <div className="login-form-container">
                        <div className="register-pending-message">
                            <div className="pending-icon">&#9888;</div>
                            <h2>Invalid Reset Link</h2>
                            <p>This password reset link is invalid or missing. Please request a new one from the login page.</p>
                            <a href="/login" className="login-button" style={{ display: 'inline-block', textAlign: 'center', textDecoration: 'none', marginTop: '20px' }}>
                                Go to Login
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="login-container">
            <div className={`login-left ${loginBgUrl ? 'login-left-image' : ''}`} style={leftStyle}>
                <div className={`login-logo-container ${loginBgUrl ? 'login-logo-overlay' : ''}`}>
                    {loginLogoUrl ? (
                        <img src={loginLogoUrl} alt={companyDisplayName} className="login-logo-img" />
                    ) : (
                        <>
                            <h1 className="login-brand">{companyDisplayName}</h1>
                            <p className="login-tagline">Product Configurator</p>
                        </>
                    )}
                </div>
            </div>
            <div className="login-right">
                <div className="login-form-container">
                    {success ? (
                        <div className="register-pending-message">
                            <div className="pending-icon">&#9989;</div>
                            <h2>Password Updated</h2>
                            <p>Your password has been reset successfully. You can now log in with your new password.</p>
                            <a href="/login" className="login-button" style={{ display: 'inline-block', textAlign: 'center', textDecoration: 'none', marginTop: '20px' }}>
                                Go to Login
                            </a>
                        </div>
                    ) : (
                        <>
                            <h2>Set New Password</h2>
                            <p className="login-subtitle">Enter your new password below</p>

                            {error && <div className="login-error">{error}</div>}

                            <form onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label htmlFor="newPassword">New Password</label>
                                    <input
                                        type="password"
                                        id="newPassword"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="At least 8 characters"
                                        required
                                        minLength={8}
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="confirmPassword">Confirm Password</label>
                                    <input
                                        type="password"
                                        id="confirmPassword"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        placeholder="Confirm your password"
                                        required
                                    />
                                </div>
                                <button
                                    type="submit"
                                    className="login-button"
                                    disabled={isLoading}
                                >
                                    {isLoading ? 'Resetting...' : 'Reset Password'}
                                </button>
                            </form>
                            <div className="login-footer">
                                <a href="/login" className="forgot-password">Back to Sign In</a>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
